"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useMutation", {
  enumerable: true,
  get: function get() {
    return _useMutation.useMutation;
  }
});
Object.defineProperty(exports, "useQuery", {
  enumerable: true,
  get: function get() {
    return _useQuery.useQuery;
  }
});
var _useQuery = require("./use-query");
var _useMutation = require("./use-mutation");